// // material-ui
// import { useTheme } from '@mui/material/styles';

// // ==============================|| BONDED WAREHOUSE LOGO ICON SVG ||============================== //

// export default function LogoIcon() {
//   const theme = useTheme();

//   return (
//     <svg
//       width="129"
//       height="129"
//       viewBox="0 0 129 129"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       {/* Warehouse Roof */}
//       <path
//         d="M20 46L64.5 20L109 46V52H20V46Z"
//         fill={theme.vars.palette.primary.dark}
//       />

//       {/* Warehouse Body */}
//       <rect
//         x="24"
//         y="52"
//         width="81"
//         height="50"
//         rx="6"
//         fill={theme.vars.palette.primary.main}
//       />

//       {/* Shutter Lines */}
//       <rect x="34" y="62" width="61" height="4" fill="#ffffff40" />
//       <rect x="34" y="70" width="61" height="4" fill="#ffffff40" />
//       <rect x="34" y="78" width="61" height="4" fill="#ffffff40" />
//       <rect x="34" y="86" width="61" height="4" fill="#ffffff40" />

//       {/* Bonded Lock */}
//       <rect
//         x="52"
//         y="92"
//         width="25"
//         height="20"
//         rx="4"
//         fill={theme.vars.palette.warning.main}
//       />
//       <path
//         d="M57 92V88C57 83 60 80 64.5 80C69 80 72 83 72 88V92"
//         stroke={theme.vars.palette.warning.dark}
//         strokeWidth="3"
//         fill="none"
//       />

//       {/* Lock Key Hole */}
//       <circle cx="64.5" cy="102" r="2" fill={theme.vars.palette.warning.dark} />
//     </svg>
//   );
// }

// material-ui
import { useTheme } from '@mui/material/styles';

// assets - aap apni images import karein
import logoIcon from '../../assets/images/users/TraceNode-Icon-01.jpg'; // Ya .svg, .jpg, .webp etc.

// ==============================|| BONDED WAREHOUSE LOGO ICON ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <img
      src={logoIcon}
      alt="Bonded Warehouse Logo"
      style={{
        width: '49px',
        height: '49px',
        objectFit: 'contain'
      }}
    />
  );
}
